var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hotTagData.length > 0)?_c('div',{staticClass:"cloud"},[_c('h2',{staticClass:"hometitle"},[_vm._v("标签云")]),_vm._v(" "),_c('ul',_vm._l((_vm.hotTagData),function(item){return _c('a',{key:item.uid,attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.goToList(item.uid)}}},[_vm._v(_vm._s(item.content))])}))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ae47841","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagCloud/index.vue
// module id = null
// module chunks = 